﻿(function (angular, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Factories").factory("Geodecode", [
    "$q",
    "$filter",
    "API",
    "Geolocation",
    function ($q, $filter, API, Geolocation) {
      return function () {
        var geodeferred = $q.defer();

        var response = {
          isSuccessful: false,
          // eslint-disable-next-line id-denylist
          data: {},
          message: "",
        };

        var addressParse = {};

        var onSuccess = function (geoData) {
          if (geoData && geoData.success) {
            var addressDecodeUrl = $filter("formatArgs")(ToyotaConsts.API.Address.GeoDecode, [
              geoData.lat,
              geoData.lng,
            ]);

            API.get(addressDecodeUrl).then(
              function (req) {
                if (!req.data.isSuccessful) {
                  response.message = req.data.message;
                  geodeferred.reject(response);
                  return;
                }

                angular.forEach(req.data.results, function (item) {
                  if (item.types[0] === "postal_code") {
                    addressParse.postcode = item.address_components[0].short_name;
                  }

                  if (item.types[0] === "locality") {
                    addressParse.suburb = item.address_components[0].short_name;
                  }

                  if (item.types[0] === "administrative_area_level_1") {
                    addressParse.state = item.address_components[0].short_name;
                  }
                });

                response.isSuccessful = true;

                // eslint-disable-next-line id-denylist
                response.data = addressParse;

                geodeferred.resolve(response);
              },
              function () {
                response.message = "failed to get the parsed address";
                geodeferred.reject(response);
              }
            );
          } else {
            response.message = "failed to get the co-ordinates from geolocation service";
            geodeferred.reject(response);
          }
        };

        var onError = function (failureData) {
          response.message = failureData ? failureData.message : "geo service unavailable";
          geodeferred.reject(response);
        };

        // Invoke Geolocation service
        var g = Geolocation.requestGeolocation();
        g.then(onSuccess, onError);

        return geodeferred.promise;
      };
    },
  ]);
})(window.angular, window.ToyotaConsts);
